import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";

import prepareForOptions from "~services/utils/prepareForOptions";

const useCidadesV2 = ({ estadoSigla = "", cidadesDisponiveis }) => {
  const [loading, setLoading] = useState(true);
  const [cidades, setCidades] = useState([]);

  const [cidadesIbge, setCidadesIbge] = useState([]);

  useEffect(() => {
    const fetchCidades = async () => {
      setLoading(true);
      const estado = await db.estados.where("sigla").equals(estadoSigla).first();
      const c = [];
      let query = db.cidades;
      if (estadoSigla) query = query.where("estadoId").equals(estado.id);
      await query.each((a) => c.push(a));
      setCidades(c);
      setLoading(false);
    };
    fetchCidades();
  }, [estadoSigla]);

  const searchCidadeById = (id) => {
    return db.cidades.get(id);
  };

  useEffect(() => {
    const fetchCidadesIbge = async (signal) => {
      let query = db.cidades;

      if (cidadesDisponiveis) {
        query = query.where("id").anyOf(cidadesDisponiveis);
      }

      const result = [];
      await query.filter((c) => c.codigoIbge).each((cidade) => result.push(cidade));
      result.sort((a, b) => a.nome.localeCompare(b.nome));

      if (!signal.aborted) {
        setCidadesIbge(result);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchCidadesIbge(signal);

    return () => {
      controller.abort();
    };
  }, [cidadesDisponiveis]);

  const optionCidades = useMemo(() => {
    const cidadesSorted = (cidadesIbge || []).sort((a, b) => {
      if (a.nome < b.nome) return -1;
      if (a.nome > b.nome) return 1;
      return 0;
    });
    return prepareForOptions(cidadesSorted, ["nome"], "id");
  }, [cidadesIbge]);

  return {
    searchCidadeById,
    loading,
    cidades,
    optionCidades,
  };
};

export default useCidadesV2;
